import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from '../../../hooks/useTranslation';

interface LogoutPromptDialogProps {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
}

const LogoutPromptDialog: React.FC<LogoutPromptDialogProps> = ({ open, onClose, onConfirm }) => {
    const { t } = useTranslation();
    return (
        <Dialog 
            open={open} 
            onClose={onClose}
            BackdropProps={{
                sx: {
                    backgroundColor: 'rgba(0, 0, 0, 0.7)',
                    backdropFilter: 'blur(5px)'
                }
            }}
        >
            <DialogTitle sx={{ 
                typography: 'h6', 
                fontWeight: 600, 
                pt: 2, 
                pb: 1, 
                px: 2 
            }}>
                {t('settings.dialogs.logoutPrompt.title')}
            </DialogTitle>
            <DialogContent sx={{ 
                p: 2 
            }}>
                <Typography sx={{ 
                    mt: 1 
                }}>
                    {t('settings.dialogs.logoutPrompt.description')}
                </Typography>
            </DialogContent>
            <DialogActions sx={{ 
                p: 2, 
                justifyContent: 'flex-end' 
            }}>
                <Button onClick={onConfirm} color="primary">
                    {t('settings.dialogs.logoutPrompt.buttons.logout')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default LogoutPromptDialog;
